import { useView } from '@10000/react'
import { Body, Box, H3 } from '../../widgets'
import { assetUrl } from '../../../utilities.js'
import { useBackground } from '../../layout'

export const Lobby = ({ active }) => {
  const { teamSize } = useView('squiz')

  useBackground().set({ active, background: null })

  return (
    <Box fullWidth height="100dvh" justifyContent="space-between" alignItems="center" column p={32} gap={32}>
      <video src={assetUrl('videos/holding-screen.mp4')} style={{ maxWidth: '100%', paddingTop: 32 }}  autoPlay muted playsInline loop />
      <H3 align="center">Your Squiz will start shortly</H3>
      <Body bold align="center" className="blink">Waiting on host to start...</Body>
      <Box>
        <Body align="center">{teamSize} TEAM MEMBER{teamSize > 1 && 'S'} JOINED</Body>
      </Box>
    </Box>
  )
}